export default "__VITE_ASSET__W5uRb7vt__"